class StockTooltip {
  constructor() {
    this.init();
    this.setupMutationObserver();
  }

  setupMutationObserver() {
    // Create mutation observer to watch for DOM changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if any added nodes contain our target elements
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (
              node.matches('variant-inventory') || 
              node.querySelector('variant-inventory')
            )) {
              console.log('Stock status updated, reinitializing tooltips');
              this.reinitialize();
            }
          });
        }
      });
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also listen for variant change events
    document.addEventListener('variant:change', () => {
      console.log('Variant changed, reinitializing tooltips');
      this.reinitialize();
    });

    document.addEventListener('variant:changed', () => {
      console.log('Variant changed (alternate event), reinitializing tooltips');
      this.reinitialize();
    });
  }

  reinitialize() {
    console.log('Reinitializing tooltips...');
    // Remove existing tooltips
    document.querySelectorAll('.stock-tooltip-container').forEach(tooltip => {
      tooltip.remove();
    });
    // Add new tooltips after a short delay to ensure DOM is updated
    setTimeout(() => {
      this.init();
    }, 100);
  }

  init() {
    // Find all stock status elements
    const stockElements = document.querySelectorAll('variant-inventory .text-with-icon');
    console.log('Found stock elements:', stockElements.length);
    
    stockElements.forEach(element => {
      // Don't add tooltip if element already has one
      if (element.querySelector('.stock-tooltip-container')) {
        return;
      }

      // Create tooltip container
      const tooltipContainer = document.createElement('span');
      tooltipContainer.className = 'stock-tooltip-container';
      tooltipContainer.style.display = 'inline-block';
      tooltipContainer.style.marginLeft = '5px';
      tooltipContainer.style.position = 'relative';
      
      // Create tooltip icon
      const tooltipIcon = document.createElement('span');
      tooltipIcon.className = 'stock-tooltip-icon';
      tooltipIcon.innerHTML = 'info';
      tooltipIcon.style.display = 'inline-flex';
      tooltipIcon.style.alignItems = 'center';
      tooltipIcon.style.justifyContent = 'center';
      tooltipIcon.style.width = '65px';
      tooltipIcon.style.height = '22px';
      tooltipIcon.style.borderRadius = '50%';
      tooltipIcon.style.backgroundColor = '#DAF7A6';
      tooltipIcon.style.color = '#000000';
      tooltipIcon.style.fontSize = '16px';
      tooltipIcon.style.cursor = 'pointer';
      
      // Create tooltip content
      const tooltipContent = document.createElement('div');
      tooltipContent.className = 'stock-tooltip-content';
      
      // Set tooltip content based on stock status
      const stockText = element.textContent.trim();
      console.log('Stock text:', stockText);
      let tooltipText = '';
      
      if (stockText.includes('På lager')) {
        tooltipText = 'Kan ses/afhentes i butikken, eller bestilles online.';
      } else if (stockText.includes('Er snart på lager')) {
        tooltipText = '__________________ Bestil gerne online, så får du besked når varen ligger klar eller afsendes. __________________';
      } else if (stockText.includes('Bestillingsvare')) {
        tooltipText = 'Leveringstiden er ca. 2 dage til 6 uger. Klik her <b> <a href="/pages/bestillingsvare/">HER</a> </b>for mere info.';
      } else if (stockText.includes('low_stock')) {
        tooltipText = 'Der er få styk tilbage af dette produkt.';
      }
      
      if (!tooltipText) {
        console.log('No matching tooltip text for:', stockText);
        return;
      }
      
      tooltipContent.innerHTML = tooltipText;
      tooltipContent.style.position = 'absolute';
      tooltipContent.style.bottom = '100%';
      tooltipContent.style.left = '110%';
      tooltipContent.style.transform = 'translateX(-50%)';
      tooltipContent.style.padding = '4px 12px';
      tooltipContent.style.backgroundColor = '#DAF7A6';
      tooltipContent.style.color = '#333';
      tooltipContent.style.border = '1px solid #e0e0e0';
      tooltipContent.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
      tooltipContent.style.borderRadius = '4px';
      tooltipContent.style.fontSize = '18px';
      tooltipContent.style.whiteSpace = 'wrap';
      tooltipContent.style.zIndex = '100';
      tooltipContent.style.display = 'none';
      tooltipContent.style.marginBottom = '8px';
      
      // Handle click events
      tooltipIcon.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevent click from immediately triggering document click
        tooltipContent.style.display = tooltipContent.style.display === 'none' ? 'block' : 'none';
      });
      
      // Close tooltip when clicking anywhere else
      document.addEventListener('click', () => {
        tooltipContent.style.display = 'none';
      });
      
      // Assemble tooltip
      tooltipContainer.appendChild(tooltipIcon);
      tooltipContainer.appendChild(tooltipContent);
      
      // Add tooltip after stock status
      element.appendChild(tooltipContainer);
      console.log('Added tooltip for:', stockText);
    });
  }
}

// Initialize on page load
let stockTooltip;
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing tooltip');
  stockTooltip = new StockTooltip();
});

// Re-initialize on Shopify section updates
document.addEventListener('shopify:section:load', () => {
  console.log('Section loaded, reinitializing tooltip');
  if (stockTooltip) {
    stockTooltip.reinitialize();
  } else {
    stockTooltip = new StockTooltip();
  }
});
